export interface BlogPost {
  slug: string;
  title: string;
  seoTitle: string;
  metaDescription: string;
  excerpt: string;
  category: string;
  image: string;
  imageAlt: string;
  date: string;
  readTime: string;
  relatedService: string;
  content: BlogSection[];
}

export interface BlogSection {
  type: "paragraph" | "heading" | "list" | "image" | "cta";
  text?: string;
  items?: string[];
  src?: string;
  alt?: string;
  level?: 2 | 3;
}

export const categories = [
  { label: "الكل", value: "all" },
  { label: "ديكورات", value: "ديكورات" },
  { label: "دهانات", value: "دهانات" },
  { label: "جبس بورد", value: "جبس بورد" },
  { label: "ورق جدران", value: "ورق جدران" },
  { label: "أرضيات", value: "أرضيات" },
];

export const blogPosts: BlogPost[] = [
  {
    slug: "best-interior-decorations-riyadh",
    title: "أفضل ديكورات داخلية للمنازل في الرياض 2025",
    seoTitle: "أفضل ديكورات داخلية للمنازل بالرياض 2025",
    metaDescription: "اكتشف أحدث صيحات الديكور الداخلي للمنازل في الرياض مع حسن عبدالله للمقاولات. تصاميم عصرية وأنيقة بأسعار مناسبة وجودة عالية.",
    excerpt: "تعرف على أحدث صيحات الديكور الداخلي في الرياض وكيف يمكنك تحويل منزلك إلى تحفة فنية بأفضل التصاميم العصرية والأنيقة.",
    category: "ديكورات",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=800&q=80",
    imageAlt: "ديكورات داخلية عصرية للمنازل في الرياض",
    date: "2025-03-15",
    readTime: "5 دقائق",
    relatedService: "/services/decorations",
    content: [
      { type: "paragraph", text: "يبحث الكثير من سكان الرياض عن أفضل الديكورات الداخلية التي تجمع بين الأناقة والعصرية والراحة. في حسن عبدالله للمقاولات والديكورات، نقدم لكم أحدث التصاميم التي تناسب جميع الأذواق." },
      { type: "heading", text: "أحدث صيحات الديكور الداخلي في 2025", level: 2 },
      { type: "paragraph", text: "تتميز صيحات الديكور لهذا العام بالبساطة والأناقة مع التركيز على المواد الطبيعية والألوان الهادئة التي تخلق أجواء مريحة ودافئة في المنزل." },
      { type: "list", items: [
        "استخدام الألوان المحايدة مع لمسات ذهبية أنيقة",
        "دمج المواد الطبيعية مثل الخشب والحجر",
        "الإضاءة المخفية والديكورية لخلق أجواء دافئة",
        "التصاميم المفتوحة التي توفر مساحات أوسع",
        "بديل الرخام عالي الجودة بأسعار مناسبة"
      ]},
      { type: "heading", text: "لماذا تختار حسن عبدالله للديكورات؟", level: 2 },
      { type: "list", items: [
        "خبرة طويلة في مجال الديكورات والتشطيبات بالرياض",
        "فريق متخصص من المصممين والفنيين المحترفين",
        "أسعار تنافسية مع ضمان الجودة العالية",
        "التزام بالمواعيد والتسليم في الوقت المحدد"
      ]},
      { type: "paragraph", text: "سواء كنت تريد تجديد صالة المعيشة أو تصميم مجلس فاخر أو تحديث غرفة النوم، فريقنا جاهز لتحويل أفكارك إلى واقع بأعلى معايير الجودة." },
    ]
  },
  {
    slug: "house-paint-colors-guide-riyadh",
    title: "دليل اختيار ألوان دهانات المنزل بالرياض",
    seoTitle: "دليل ألوان دهانات المنزل بالرياض 2025",
    metaDescription: "دليل شامل لاختيار أفضل ألوان الدهانات للمنازل في الرياض. نصائح من خبراء حسن عبدالله لاختيار الألوان المناسبة لكل غرفة.",
    excerpt: "دليل شامل يساعدك في اختيار أفضل ألوان الدهانات لمنزلك مع نصائح احترافية من خبراء الدهانات في الرياض.",
    category: "دهانات",
    image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&q=80",
    imageAlt: "ألوان دهانات حديثة للمنازل في الرياض",
    date: "2025-03-10",
    readTime: "4 دقائق",
    relatedService: "/services/paint",
    content: [
      { type: "paragraph", text: "اختيار ألوان الدهانات المناسبة لمنزلك يمكن أن يحدث فرقاً كبيراً في الشعور العام بالمكان. في هذا الدليل، نشاركك أسرار اختيار الألوان المثالية." },
      { type: "heading", text: "أفضل ألوان الدهانات لكل غرفة", level: 2 },
      { type: "heading", text: "غرفة المعيشة", level: 3 },
      { type: "paragraph", text: "الألوان المحايدة مثل البيج والرمادي الفاتح تعطي إحساساً بالاتساع والأناقة. يمكن إضافة جدار مميز بلون غامق لإضفاء الحيوية." },
      { type: "heading", text: "غرف النوم", level: 3 },
      { type: "paragraph", text: "الألوان الهادئة مثل الأزرق الفاتح واللافندر والأخضر الزيتوني تساعد على الاسترخاء وتحسين جودة النوم." },
      { type: "heading", text: "نصائح مهمة قبل اختيار الدهانات", level: 2 },
      { type: "list", items: [
        "جرّب اللون على مساحة صغيرة أولاً قبل طلاء الجدار كاملاً",
        "ضع في اعتبارك الإضاءة الطبيعية للغرفة",
        "استخدم دهانات عالية الجودة لضمان اللون والمتانة",
        "اختر الألوان التي تتناسب مع الأثاث والديكور الحالي",
        "استشر خبير دهانات محترف للحصول على أفضل النتائج"
      ]},
      { type: "paragraph", text: "في حسن عبدالله للمقاولات، نوفر أفضل أنواع الدهانات الداخلية والخارجية مع فريق من أمهر معلمي الدهانات في الرياض." },
    ]
  },
  {
    slug: "gypsum-board-designs-riyadh",
    title: "أحدث تصاميم جبس بورد للأسقف والجدران بالرياض",
    seoTitle: "تصاميم جبس بورد للأسقف بالرياض 2025",
    metaDescription: "شاهد أحدث تصاميم الجبس بورد للأسقف والجدران في الرياض. أعمال احترافية من حسن عبدالله مع إضاءة مخفية وتصاميم عصرية.",
    excerpt: "استكشف أحدث تصاميم الجبس بورد للأسقف والجدران مع إضاءة مخفية وديكورات عصرية تناسب المنازل والمجالس في الرياض.",
    category: "جبس بورد",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
    imageAlt: "تصاميم جبس بورد حديثة للأسقف في الرياض",
    date: "2025-03-05",
    readTime: "4 دقائق",
    relatedService: "/services/gypsum",
    content: [
      { type: "paragraph", text: "أصبح الجبس بورد من أهم عناصر الديكور الداخلي في المنازل الحديثة بالرياض. يوفر تصاميم متنوعة وعصرية تضيف لمسة جمالية فريدة لأي مساحة." },
      { type: "heading", text: "أنواع تصاميم الجبس بورد", level: 2 },
      { type: "list", items: [
        "أسقف مستعارة بتصاميم هندسية حديثة",
        "أسقف مع إضاءة LED مخفية",
        "ديكورات جدارية بالجبس بورد",
        "تصاميم خاصة للمجالس والصالات",
        "أعمال جبس بورد لغرف النوم"
      ]},
      { type: "heading", text: "مميزات الجبس بورد", level: 2 },
      { type: "list", items: [
        "خفيف الوزن وسهل التركيب",
        "عازل للصوت والحرارة",
        "مقاوم للرطوبة (الأنواع المقاومة للماء)",
        "قابل للتشكيل بتصاميم متعددة",
        "سعره مناسب مقارنة بالبدائل الأخرى"
      ]},
      { type: "paragraph", text: "نقدم في حسن عبدالله أعمال جبس بورد احترافية بتصاميم مبتكرة تناسب جميع المساحات والأذواق، مع ضمان جودة التنفيذ والالتزام بالمواعيد." },
    ]
  },
  {
    slug: "wallpaper-trends-riyadh-2025",
    title: "أحدث صيحات ورق الجدران في الرياض 2025",
    seoTitle: "أحدث ورق جدران بالرياض 2025 | تركيب احترافي",
    metaDescription: "تعرف على أحدث موديلات ورق الجدران في الرياض مع خدمة تركيب احترافية من حسن عبدالله. تصاميم فاخرة بأسعار تنافسية.",
    excerpt: "اكتشف أحدث صيحات ورق الجدران لعام 2025 وكيف يمكن لورق الجدران أن يحول مساحتك إلى تحفة فنية بأقل تكلفة.",
    category: "ورق جدران",
    image: "/images/blog-wallpaper.jpg",
    imageAlt: "ورق جدران حديث وفاخر في الرياض",
    date: "2025-02-28",
    readTime: "3 دقائق",
    relatedService: "/services/wallpaper",
    content: [
      { type: "paragraph", text: "ورق الجدران من أسرع وأسهل الطرق لتغيير شكل أي غرفة بالكامل. مع تنوع التصاميم والخامات المتاحة، أصبح ورق الجدران الخيار المفضل للكثيرين في الرياض." },
      { type: "heading", text: "أنواع ورق الجدران الرائجة", level: 2 },
      { type: "list", items: [
        "ورق جدران ثلاثي الأبعاد (3D) لمظهر عصري",
        "ورق جدران بنقشات طبيعية وأزهار",
        "ورق جدران بتصاميم هندسية أنيقة",
        "ورق جدران مخملي فاخر للمجالس",
        "ورق جدران مقاوم للرطوبة للمطابخ والحمامات"
      ]},
      { type: "heading", text: "نصائح لاختيار ورق الجدران المناسب", level: 2 },
      { type: "list", items: [
        "اختر تصميماً يتناسب مع طراز الغرفة والأثاث",
        "تأكد من جودة الخامة ومقاومتها للعوامل البيئية",
        "استعن بمتخصص في التركيب لضمان نتيجة مثالية",
        "اطلب عينات قبل الشراء لرؤية اللون الحقيقي"
      ]},
      { type: "paragraph", text: "نوفر في حسن عبدالله أفخر أنواع ورق الجدران المستوردة مع خدمة تركيب احترافية سريعة وبأسعار منافسة." },
    ]
  },
  {
    slug: "parquet-flooring-guide-riyadh",
    title: "دليل اختيار وتركيب الباركيه في الرياض",
    seoTitle: "تركيب باركيه بالرياض | دليل شامل 2025",
    metaDescription: "دليلك الشامل لاختيار وتركيب أرضيات الباركيه في الرياض. أنواع الباركيه ومميزاته مع خدمة تركيب احترافية من حسن عبدالله.",
    excerpt: "كل ما تحتاج معرفته عن أرضيات الباركيه: الأنواع، المميزات، طريقة الاختيار، والتركيب الاحترافي في الرياض.",
    category: "أرضيات",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&q=80",
    imageAlt: "أرضيات باركيه فاخرة في منزل بالرياض",
    date: "2025-02-20",
    readTime: "5 دقائق",
    relatedService: "/services/parquet",
    content: [
      { type: "paragraph", text: "أرضيات الباركيه تضيف لمسة من الفخامة والدفء لأي مساحة. سواء كنت تبني منزلاً جديداً أو تجدد أرضيات منزلك الحالي، الباركيه خيار مثالي يجمع بين الجمال والمتانة." },
      { type: "heading", text: "أنواع أرضيات الباركيه", level: 2 },
      { type: "list", items: [
        "باركيه خشب طبيعي — أعلى جودة وفخامة",
        "باركيه HDF — متانة عالية وسعر مناسب",
        "باركيه SPC — مقاوم للماء ومناسب لجميع المساحات",
        "باركيه لامينيت — اقتصادي مع مظهر أنيق"
      ]},
      { type: "heading", text: "مميزات أرضيات الباركيه", level: 2 },
      { type: "list", items: [
        "مظهر فاخر وأنيق يرفع قيمة العقار",
        "سهولة التنظيف والصيانة",
        "عمر افتراضي طويل مع العناية المناسبة",
        "عازل طبيعي للصوت والحرارة",
        "تنوع كبير في الألوان والتصاميم"
      ]},
      { type: "paragraph", text: "في حسن عبدالله للمقاولات نوفر جميع أنواع الباركيه الفاخر مع خدمة تركيب احترافية من فنيين متخصصين وبضمان على التركيب." },
    ]
  },
  {
    slug: "renovation-tips-riyadh",
    title: "نصائح ذهبية لترميم وتجديد منزلك بالرياض",
    seoTitle: "نصائح ترميم وتجديد المنازل بالرياض 2025",
    metaDescription: "نصائح احترافية لترميم وتجديد منزلك في الرياض بأقل تكلفة وأعلى جودة. خطوات عملية من خبراء حسن عبدالله للمقاولات.",
    excerpt: "نصائح عملية واحترافية تساعدك في ترميم وتجديد منزلك في الرياض بأفضل النتائج وأقل التكاليف.",
    category: "ديكورات",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80",
    imageAlt: "ترميم وتجديد منزل حديث في الرياض",
    date: "2025-02-15",
    readTime: "6 دقائق",
    relatedService: "/services/decorations",
    content: [
      { type: "paragraph", text: "تجديد المنزل لا يعني بالضرورة إنفاق مبالغ كبيرة. مع التخطيط الصحيح واختيار المتخصصين المناسبين، يمكنك تحويل منزلك بالكامل بميزانية معقولة." },
      { type: "heading", text: "خطوات التجديد الناجح", level: 2 },
      { type: "list", items: [
        "حدد ميزانيتك بدقة قبل البدء",
        "ضع خطة واضحة لأولويات التجديد",
        "اختر مقاول موثوق وذو خبرة",
        "لا تبخل على المواد الأساسية",
        "احصل على عروض أسعار من أكثر من جهة"
      ]},
      { type: "heading", text: "أكثر المناطق تأثيراً عند التجديد", level: 2 },
      { type: "list", items: [
        "المجلس والصالة — الانطباع الأول للضيوف",
        "المطبخ — قلب المنزل",
        "الحمامات — راحة يومية",
        "غرف النوم — استرخاء وراحة",
        "الواجهة الخارجية — المظهر العام"
      ]},
      { type: "paragraph", text: "مع حسن عبدالله للمقاولات والديكورات، نضمن لك تجديداً شاملاً ومتكاملاً لمنزلك بأعلى معايير الجودة وبأسعار تنافسية في الرياض." },
    ]
  },
  {
    slug: "decorations-apartments-riyadh",
    title: "أفضل ديكورات شقق بالرياض 2026",
    seoTitle: "أفضل ديكورات شقق بالرياض 2026 | أفكار مودرن وتشطيبات فخمة",
    metaDescription: "تعرف على أفضل أفكار ديكورات شقق بالرياض 2026، تصميمات مودرن وتشطيبات فاخرة بأسعار مناسبة مع تنفيذ احترافي.",
    excerpt: "اكتشف أحدث أفكار ديكورات الشقق المودرن بالرياض مع نصائح اختيار التصميم المناسب وأسعار تنافسية وتنفيذ احترافي من حسن عبدالله للمقاولات.",
    category: "ديكورات",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80",
    imageAlt: "ديكورات شقق مودرن بالرياض 2026 - تصميم داخلي فاخر",
    date: "2026-04-01",
    readTime: "7 دقائق",
    relatedService: "/services/decorations",
    content: [
      { type: "paragraph", text: "تُعد ديكورات الشقق من أهم العوامل التي تؤثر على جودة الحياة اليومية، فالمنزل ليس مجرد مكان للسكن بل هو مساحة للراحة والإبداع والتعبير عن الذوق الشخصي. في مدينة الرياض التي تشهد نهضة عمرانية متسارعة، يزداد الطلب على ديكورات شقق بالرياض تجمع بين الأناقة العصرية والوظيفية العملية. سواء كنت تملك شقة جديدة أو ترغب في تجديد شقتك الحالية، فإن اختيار الديكور المناسب يُحدث فرقاً كبيراً في الشعور بالمكان ويرفع من قيمة العقار." },
      { type: "paragraph", text: "في هذا المقال الشامل، نستعرض لك أفضل أفكار ديكورات شقق بالرياض لعام 2026، مع نصائح عملية من خبراء التصميم الداخلي بالرياض لمساعدتك في تحويل شقتك إلى مساحة أنيقة ومريحة تعكس شخصيتك وتلبي احتياجات عائلتك." },

      { type: "heading", text: "أحدث أفكار ديكورات شقق مودرن بالرياض", level: 2 },
      { type: "paragraph", text: "تتطور صيحات الديكور المودرن بالرياض باستمرار، وتتميز تصاميم 2026 بالتركيز على البساطة والفخامة معاً. إليك أبرز الأفكار التي يمكنك تطبيقها في شقتك لتحصل على تشطيبات شقق بالرياض بمستوى احترافي:" },
      { type: "list", items: [
        "بديل الرخام (PVC Marble): من أكثر المواد رواجاً في ديكورات الشقق بالرياض، يوفر مظهراً فاخراً يحاكي الرخام الطبيعي بتكلفة أقل بكثير، مع سهولة التركيب والتنظيف ومقاومة عالية للرطوبة والخدوش. مثالي للجدران والأعمدة والمداخل.",
        "بديل الخشب: يُضفي الدفء والأناقة على المساحات الداخلية، متوفر بألوان وتصاميم متنوعة تناسب جميع الأذواق. يُستخدم في تكسية الجدران وتصميم خلفيات التلفزيون والممرات، وهو مقاوم للحرارة والرطوبة.",
        "الجبس بورد: عنصر أساسي في التصميم الداخلي بالرياض، يتيح تصاميم أسقف مبتكرة مع إضاءات مخفية تخلق أجواء ساحرة. يمكن تشكيله بأنماط هندسية عصرية أو كلاسيكية حسب الذوق.",
        "ورق الجدران: حلول سريعة وأنيقة لتغيير مظهر أي غرفة، مع تشكيلة واسعة من النقشات ثلاثية الأبعاد والتصاميم الفاخرة. مناسب للمجالس وغرف النوم وغرف المعيشة.",
        "الإضاءة المخفية: من أهم عناصر ديكورات الشقق المودرن، تُستخدم في الأسقف والجدران والأرضيات لخلق طبقات إضاءة متعددة تعطي عمقاً وفخامة للمساحة. تشمل شرائط LED وإضاءات سبوت لايت موجهة."
      ]},

      { type: "heading", text: "كيف تختار الديكور المناسب لشقتك؟", level: 2 },
      { type: "paragraph", text: "اختيار ديكورات شقق بالرياض يتطلب دراسة عدة عوامل لضمان نتيجة متناسقة وعملية. إليك أهم النصائح من خبراء التصميم الداخلي بالرياض:" },

      { type: "heading", text: "اختيار الألوان المناسبة", level: 3 },
      { type: "paragraph", text: "الألوان هي أساس أي تصميم داخلي ناجح. في الشقق بالرياض، يُفضل استخدام الألوان المحايدة كالبيج والرمادي الفاتح والأبيض الكريمي كقاعدة أساسية، مع إضافة لمسات من الألوان الغنية مثل الأزرق الداكن أو الأخضر الزيتوني أو الذهبي لإضفاء الحيوية. تجنب استخدام أكثر من ثلاثة ألوان رئيسية في الغرفة الواحدة للحفاظ على التناسق البصري." },

      { type: "heading", text: "التعامل مع المساحات الصغيرة", level: 3 },
      { type: "paragraph", text: "كثير من الشقق في الرياض تأتي بمساحات محدودة، وهنا يأتي دور التصميم الذكي. استخدم المرايا الكبيرة لإعطاء إيحاء بالاتساع، واختر أثاثاً متعدد الاستخدامات، واعتمد على الألوان الفاتحة في الجدران والأسقف. الإضاءة الطبيعية والمخفية تلعب دوراً كبيراً في جعل المساحات الصغيرة تبدو أكبر وأكثر انفتاحاً." },

      { type: "heading", text: "التناسق بين الغرف", level: 3 },
      { type: "paragraph", text: "من أهم قواعد التصميم الداخلي بالرياض الحفاظ على خط تصميمي موحد في جميع أرجاء الشقة. اختر طراز ديكور واحد (مودرن، نيوكلاسيك، مينيمال) والتزم به في جميع الغرف مع تنويع بسيط في التفاصيل. هذا يخلق شعوراً بالانسجام والراحة البصرية." },

      { type: "heading", text: "أسعار ديكورات الشقق في الرياض", level: 2 },
      { type: "paragraph", text: "تختلف أسعار تشطيبات شقق بالرياض بناءً على عدة عوامل منها: مساحة الشقة، نوعية المواد المستخدمة، مستوى التشطيب المطلوب (ديلوكس أو سوبر ديلوكس)، وتعقيد التصميم. بشكل عام، تتوفر خيارات تناسب مختلف الميزانيات من التشطيبات الاقتصادية وحتى الفاخرة." },
      { type: "paragraph", text: "في حسن عبدالله للمقاولات والديكورات، نقدم أسعاراً تنافسية مع الحفاظ على أعلى معايير الجودة. نؤمن بأن الديكور الفاخر لا يجب أن يكون باهظ الثمن، ولذلك نوفر باقات متنوعة تناسب جميع الميزانيات مع إمكانية التقسيط. احصل على عرض سعر مجاني ومفصل قبل بدء التنفيذ لتعرف التكلفة الدقيقة لمشروعك." },

      { type: "heading", text: "لماذا تختار حسن عبدالله للمقاولات والديكورات؟", level: 2 },
      { type: "paragraph", text: "عندما يتعلق الأمر بتنفيذ ديكورات شقق بالرياض باحترافية وجودة عالية، فإن حسن عبدالله للمقاولات والديكورات هو خيارك الأمثل. إليك ما يميزنا:" },
      { type: "list", items: [
        "خبرة واسعة: سنوات طويلة من الخبرة في مجال المقاولات والديكورات بالرياض، نفذنا خلالها مئات المشاريع السكنية والتجارية بمختلف الأحجام والمستويات.",
        "جودة عالية: نستخدم أفضل المواد والخامات المعتمدة مع ضمان على جميع الأعمال. نحرص على أن تكون كل تفصيلة مثالية من البداية حتى التسليم النهائي.",
        "سرعة تنفيذ: نلتزم بالجدول الزمني المتفق عليه ونسلم المشاريع في وقتها دون تأخير. فريقنا المتخصص مجهز للعمل بكفاءة عالية دون المساومة على الجودة.",
        "أسعار مناسبة: نقدم أسعاراً تنافسية تناسب جميع الميزانيات مع عروض وخصومات دورية. نوفر عرض سعر مجاني ومفصل قبل البدء حتى تعرف التكلفة بدقة.",
        "فريق متكامل: من مصممين ومهندسين وفنيين محترفين يعملون بتناغم لتحقيق رؤيتك وتحويل أفكارك إلى واقع يفوق توقعاتك.",
        "استشارة مجانية: نقدم استشارة تصميمية مجانية لمساعدتك في اختيار الديكور الأنسب لشقتك وميزانيتك."
      ]},

      { type: "heading", text: "تواصل معنا الآن لتنفيذ أفضل ديكور", level: 2 },
      { type: "paragraph", text: "لا تترك شقتك بدون لمسة جمالية تستحقها! فريق حسن عبدالله للمقاولات والديكورات جاهز لتحويل شقتك إلى تحفة فنية بأفضل ديكورات شقق بالرياض وبأسعار تنافسية لا تُضاهى." },
      { type: "paragraph", text: "سواء كنت تبحث عن تصميم داخلي بالرياض لشقة جديدة أو ترغب في تجديد شقتك الحالية بديكورات مودرن بالرياض، نحن هنا لمساعدتك في كل خطوة من التخطيط وحتى التسليم. اتصل الآن على 0556641963 واحصل على استشارة مجانية وعرض سعر خاص." },
    ]
  },
];
